export enum ReviewOptions {
    goed = 'Goed',
    matig = 'Matig',
    slecht = 'Slecht',
}
